import { BadgeWithTooltip } from 'components/WithTooltip/BadgeWithTooltip';
import type { WorkOrderOtherPriceData, WorkOrderStatusEnum } from 'gql/graphql';
import { IconWarning } from 'uikit';
import { formatNumberToRu } from 'utils';

import type { ICellRendererParams } from 'ag-grid-community';
import React from 'react';

export const WorkOrderOtherSeasonPlanCell = (
    params: ICellRendererParams<WorkOrderOtherPriceData> & {
        seasonId: number;
        handleUpdateValue: (data: WorkOrderOtherPriceData | undefined, seasonId: number, value: number) => void;
        decimal: number;
        workOrderStatus: WorkOrderStatusEnum;
        isDisabled: boolean;
        columnKey: string;
    },
) => {
    const { seasonId, decimal = 2, data } = params;

    const { errors, hasErrors } = data?.seasonPrices?.find((season) => season.seasonId === seasonId) || {};

    if (hasErrors && errors) {
        return (
            <BadgeWithTooltip
                messages={errors}
                size="l"
                badgeSize="s"
                label="Ошибка"
                status="error"
                iconLeft={IconWarning}
            />
        );
    }

    return <span>{formatNumberToRu((data as any)[`seasonValue_${seasonId}`], decimal)}</span>;
};

WorkOrderOtherSeasonPlanCell.displayName = 'WorkOrderOtherSeasonEditableCell';
